import { WithTranslationProps } from 'react-i18next/*';

import { BaseEntityPropsInitial, IBaseEntityProps } from '../BaseEntity/IBaseEntityProps';
import { InitialReportHelperProps, IReportHelperProps } from './IHelperProps';
import { ReportDTO } from './ReportDTO';

export interface IReportProps extends IBaseEntityProps<ReportDTO, IReportHelperProps<any>>, WithTranslationProps {
}

export const ReportPropsInitial: IReportProps = { ...BaseEntityPropsInitial,  DataHelper: InitialReportHelperProps };